// import { readJson } from '../../services/fileOps'
// import Marker from './marker'
// import Schema from './schema'
import {BasicManagedFile} from './basicManagedFile'
import { CLI } from '../Data/typeDirs'
// import { MASK_FLAG } from '../ControlManager/scripts/utils'
// import { upgradeOldLang } from '../ControlManager/scripts/legacy'

class Client extends BasicManagedFile {

  constructor(args){
    super(args)
    this.ext = Client.getExt()
    this.typeDir = Client.getTypeDir()
    this.type = Client.getTypeDir()
  }

  static getIndices(){
    return `${super.getIndices()}`
  }

  static getExt(){
    return 'client.json'
  }

  static getTypeDir(){
    return CLI
  }

  static initialize(){

    return {
      'data':{
        schema:[
          {name:'nameContainer', type: 'page', children:[
            {name: 'name', label: 'Client Name', type: 'text', options:['edit']},
          ]},
          {name:'secondaryContainer', type:'page', children:[
            {name: 'address', label: 'Client Address', type: 'text', options:['edit', 'large']},
            {name: 'contacts', label: 'Client Contacts', type:'text', options:['edit', 'large']},
            {name: 'info', label: 'Additional Info', type:'text', options:['edit', 'large']}
          ]}
        ],
        source:{}
      }
    }
  }

  getAddress(){
    return this.content.getData().data.tree.address.content[0] && this.content.getData().data.tree.address.content[0]._name
  }
  construct(data){

    return super.construct(data)

  }



}

export default Client
